
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { PanelPosition, UIPanel } from "@/types/ui";

/**
 * Intended to be used within AppLayout's "body" slot.
 */
@Component
export default class AppLayoutBodyPanelArea extends Vue {
  @Prop()
  position!: PanelPosition;

  @Prop()
  panelState!: UIPanel | "closed";

  get classList() {
    if (this.panelState === "closed") return {};

    return {
      width288: true,
      "vscroll-wrap": true,
      borderOnLeft: this.position === "right",
      borderOnRight: this.position === "left",
      "breakdance-app-left-area": this.position === "left",
      "breakdance-app-right-area": this.position === "right"
    };
  }
}
